"use client";
import Image from "next/image";
import { useMotionValue, useSpring } from "motion/react";
import * as m from "motion/react-m";
import * as React from "react";
import { ButtonLink } from "@/app/[locale]/(legacy)/customer-transformation-report/components/ButtonLink";

const TILT_INTENSITY = 10; // Max degrees of rotation
const SPRING_CONFIG = { stiffness: 300, damping: 50 };

export const AnimatedTile = () => {
  const ref = React.useRef<HTMLDivElement>(null);

  const rotateX = useMotionValue(0);
  const rotateY = useMotionValue(0);

  const springRotateX = useSpring(rotateX, SPRING_CONFIG);
  const springRotateY = useSpring(rotateY, SPRING_CONFIG);

  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    if (!ref.current) return;

    const rect = ref.current.getBoundingClientRect();
    const centerX = rect.left + rect.width / 2;
    const centerY = rect.top + rect.height / 2;

    // Calculate offset from center (-1 to 1)
    const offsetX = (e.clientX - centerX) / (rect.width / 2);
    const offsetY = (e.clientY - centerY) / (rect.height / 2);

    // rotateY for left/right tilt, rotateX for up/down tilt (inverted)
    rotateX.set(-offsetY * TILT_INTENSITY);
    rotateY.set(offsetX * TILT_INTENSITY);
  };

  const handleMouseLeave = () => {
    rotateX.set(0);
    rotateY.set(0);
  };

  return (
    <div
      ref={ref}
      className="bg-report-grey-200 relative flex aspect-[627/625] flex-col"
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
    >
      <div className="grid h-full min-h-0 flex-1 place-items-center p-8 md:p-12 lg:p-20">
        <div className="perspective-distant aspect-[320/480] h-full w-auto">
          <m.div
            className="h-full"
            style={{
              rotateX: springRotateX,
              rotateY: springRotateY,
              transformStyle: "preserve-3d",
            }}
          >
            <Image
              src="/intercom-marketing-site/img/transformation-report/book-cover.svg"
              alt="Customer Transformation Report 2026 Cover"
              width={320}
              height={480}
              className="h-full w-auto"
            />
          </m.div>
        </div>
      </div>
      <div className="shrink-0 px-2 pb-2">
        <ButtonLink label="Download the report" href="#report-form" />
      </div>
    </div>
  );
};
